<template>
<div>
    <a-modal v-model="departmentModalVisible" :title="newDepartment ? 'Nieuwe Afdeling' : 'Afdeling aanpassen'" :ok-text="newDepartment ? 'Aanmaken' : 'Aanpassen'" cancel-text="Annuleren" @ok="createOrUpdateDepartment">
          <p class="input-label">Organisatienaam</p>
          <a-input class="mb-2" v-model="departmentInformation.name" />
          <p class="input-label">Straatnaam + Huisnummer</p>
          <a-input class="mb-2" v-model="departmentInformation.streetname_housenumber" />
          <p class="input-label">Postcode</p>
          <a-input class="mb-2" v-model="departmentInformation.zipcode" />
          <p class="input-label">Stad</p>
          <a-input class="mb-2" v-model="departmentInformation.city" />
          <p class="input-label">Land</p>
          <a-input class="mb-2" v-model="departmentInformation.country" />
          <p class="input-label">Telefoonnummer</p>
          <a-input class="mb-2" v-model="departmentInformation.phone_number" />
          <p class="input-label">KVK nummer</p>
          <a-input class="mb-2" v-model="departmentInformation.coc_number" />
          <p class="input-label">Factuur e-mailadres</p>
          <a-input class="mb-2" v-model="departmentInformation.invoice_email" />
          <p class="input-label">Contactpersoon naam</p>
          <a-input class="mb-2" v-model="departmentInformation.contact_name" />
          <p class="input-label">Contactpersoon e-mailadres</p>
          <a-input class="mb-2" v-model="departmentInformation.contact_email" />
    </a-modal>
</div>
</template>
<script>
export default {
  props: ['fetchOrganizations'],
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data() {
    return {
      departmentModalVisible: false,
      departmentInformation: {},
      emptyDepartmentInformation: {
        name: undefined,
        zipcode: undefined,
        streetname_housenumber: undefined,
        phone_number: undefined,
        coc_number: undefined,
        country: 'Nederland',
        city: undefined,
        invoice_email: undefined,
        contact_name: undefined,
        contact_email: undefined,
      },
      newDepartment: true,
    }
  },
  methods: {
    openModal(organizationId = undefined, departmentInformation = this.emptyDepartmentInformation) {
      this.departmentModalVisible = true
      this.departmentInformation = departmentInformation
      this.newDepartment = false
      if (organizationId !== undefined) {
        this.newDepartment = true
        this.departmentInformation.organization_id = organizationId
      }
      console.log(this.departmentInformation)
    },
    createOrUpdateDepartment() {
      this.$axios.post(`/organization/department/createOrUpdate`, {
        organization_id: this.departmentInformation.organization_id ? this.departmentInformation.organization_id : null,
        department_id: this.departmentInformation.id ? this.departmentInformation.id : null,
        department: this.departmentInformation,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.departmentModalVisible = false
        this.fetchOrganizations()
      }).catch(error => {
        console.log(error)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap');

  .input-label{
    margin-bottom: 0px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 10px;
  }
</style>